import { Slot } from "@radix-ui/react-slot";
import { LabelHTMLAttributes, forwardRef } from "react";

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
  asChild?: boolean;
};

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ asChild, ...props }, ref): React.ReactElement => {
    const Comp: React.ElementType = asChild ? Slot : "label";

    return <Comp ref={ref as React.LegacyRef<HTMLLabelElement>} {...props} />;
  },
);

Label.displayName = "Label";
